import { Context } from '@vue-storefront/core';
import Cache from '../cache/cache';

export default async function shopConfigAll(ctx: Context, params: any): Promise<Object> {
  const { client, config, } = ctx;

  const cacheKey = 'shopConfigAll';
  if (!params || !params.debug) {
    const cache = Cache.getCache(ctx, cacheKey);
    if (cache) {
      return cache;
    }
  }

  try {
    const url = new URL('/mall/shop-config/all', config.api.url);
    const { data: res } = await client.post(url.href, params);
    // console.log('------------shopConfig-----', res);
    if (res && res.message === 'no_shop_find') {
      return { error: 'no_shop_find' };
    }

    const result = res?.data?.data || {};
    Cache.setCache(ctx, cacheKey, result);
    return result;
  } catch (e) {
    return { error: e }
  }
}
